<template>
  <Modal
    :is-open="isOpen"
    :title="$t('ui.entities.task.reminder', 2)"
    description="Add reminders to keep track of important tasks."
    :buttons="[]"
    close-text="Close"
    min-width="400"
    icon="bell"
    @close-modal="$emit('close')"
  >
    <div>
      <TaskListItem
        v-for="task in reminders"
        :key="task.id"
        :task="task"
        :chips="[]"
        :description-length="70"
        @update-task="$emit('update-task', $event)"
        @task-clicked="$emit('task-clicked', $event)"
      />
    </div>
    <Button
      :label="$t('ui.crud.new', { item: $t('ui.entities.task.reminder') })"
      outlined
      icon="plus"
      class="mt-4"
      @click="$emit('new-reminder')"
    />
  </Modal>
</template>

<script setup lang="ts">
// types
import type { Task } from '@/types/domain/tasks'

// components
import Modal from '@/components/modal/Modal.vue'
import Button from '@/components/button/Button.vue'
import TaskListItem from '@/components/tasks/TaskListItem.vue'

interface Props {
  isOpen: boolean
  reminders: Task[]
}

defineProps<Props>()

defineEmits<{
  close: []
  'update-task': [task: Task]
  'task-clicked': [task: Task]
  'new-reminder': []
}>()
</script>
